import {Injectable} from "@angular/core";
import {UserModel, userModelFactory} from "../types/user.model";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 10;

@Injectable()
export class ServiceAccountService {
  private url: string = "/api/ServiceAccount";

  constructor(private http: HttpClient) {}

  getServiceAccounts(
    page = DEFAULT_PAGE,
    limit = DEFAULT_PAGE_LIMIT,
    search?: string,
  ): Promise<{rows: any[], count: number}> {
    const params = {
      ...page && {page: `${page}`},
      ...limit && {limit: `${limit}`},
      ...search && {search},
      sequence: "true",
    };

    return this.http.get<{rows: any[], count: any}>(`${this.url}`, {params})
      .pipe(map(json => ({rows: Array.from(json.rows || []), count: +json.count})))
      .toPromise();
  }

  getServiceAccountById(id): Promise<any> {
    return this.http.get<{user: any, roles: any, userRoles: any}>(`${this.url}?id=${id || "new"}`)
      .pipe(map(({roles, userRoles, user}) => ({user: userModelFactory(user), userRoles, roles})))
      .toPromise();
  }

  saveUserWithRoles(user: UserModel, selectedRoles = []): Promise<any> {
    return this.http.post(`${this.url}/save-with-roles`, {selectedRoles, ...user})
      .pipe(map(obj => obj["id"]))
      .toPromise();
  }

  resetIncomingToken(id): Promise<{data: string, authenticationMechanism: string}> {
    return this.http.post(`${this.url}/reset-incoming-token`, {id})
      .pipe(map(json => ({data: `${json["data"]}`, authenticationMechanism: `${json["authenticationMechanism"]}`})))
      .toPromise();
  }

  resetOutgoingToken(id): Promise<{data: string, authenticationMechanism: string}> {
    return this.http.post(`${this.url}/reset-outgoing-token`, {id})
      .pipe(map(json => ({data: `${json["data"]}`, authenticationMechanism: `${json["authenticationMechanism"]}`})))
      .toPromise();
  }

  updateOutgoingToken(id, key, secret): Promise<{data: string, authenticationMechanism: string}> {
    return this.http.post(`${this.url}/update-outgoing-token`, {id, key, secret})
      .pipe(map(json => ({data: `${json["data"]}`, authenticationMechanism: `${json["authenticationMechanism"]}`})))
      .toPromise();
  }

  useIncomingAsOutgoingToken(id): Promise<{data: string, authenticationMechanism: string}> {
    return this.http.post(`${this.url}/use-incoming-outgoing-token`, {id})
      .pipe(map(json => ({data: `${json["data"]}`, authenticationMechanism: `${json["authenticationMechanism"]}`})))
      .toPromise();
  }

  getPartners({id, name, webhooks}): Promise<any> {
    const params = {
      ...id && {id: `${id}`},
      ...name && {name: `${name}`},
      ...webhooks && {webhooks: JSON.stringify(webhooks)},
    };

    return this.http.get(`${this.url}/get-partners`, {params})
      .toPromise();
  }
}
